export default __webpack_public_path__ + "static/media/hospice-1797305_1920.62dbfcb9.jpg";